import e, { useState as k, useEffect as x, useMemo as i } from "react";
import t from "./index170.mjs";
import M from "./index171.mjs";
import K from "./index133.mjs";
import L from "./index131.mjs";
import { formatDateRange as S } from "./index172.mjs";
import { getConfigPropertyAtomCreator as E, ConfigProperty as p } from "./index13.mjs";
import { useAtomValue as _ } from "jotai";
import { Close as R } from "./index173.mjs";
import { getGuests as G } from "./index158.mjs";
import v from "classnames";
import "./index168.mjs";
const U = ({
  searchInputs: o,
  onClose: m,
  title: n,
  onBack: l,
  subTitle: c,
  isFullScreenLayout: s = !1,
  roomsCount: r
}) => {
  const [d, u] = k(!1);
  x(() => {
    const a = window.matchMedia("(max-width: 768px)");
    u(a.matches);
    const g = (A) => {
      u(A.matches);
    };
    return a.addEventListener("change", g), () => a.removeEventListener("change", g);
  }, []);
  const N = (a) => {
    (a.key === "Enter" || a.key === " ") && l && (a.preventDefault(), l());
  }, y = _(
    i(() => E(p.LOCALE), [])
  ), D = _(
    i(
      () => E(p.MAX_CHILDREN),
      []
    )
  ) > "0", { arrivalDate: b, departureDate: f, totalAdults: w, totalChildren: C } = o || {
    arrivalDate: null,
    departureDate: null,
    totalAdults: 2,
    totalChildren: 0
  }, h = i(() => d && r !== void 0 && n.includes("Your search") ? `Your search (${r}):` : n, [d, r, n]), I = (a) => {
    (a.key === "Enter" || a.key === " ") && (a.preventDefault(), l == null || l());
  };
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: v(t.header_container, {
        [t.header_container_fullscreen]: s
      })
    },
    /* @__PURE__ */ e.createElement("div", { className: t.header, "data-testid": "be-header" }, l ? /* @__PURE__ */ e.createElement(
      "button",
      {
        className: t.back,
        onClick: l,
        onKeyDown: N,
        "data-testid": "back-button",
        "aria-label": I18n.t("booking_engine.buttons.back"),
        type: "button"
      },
      /* @__PURE__ */ e.createElement(M, null)
    ) : null, /* @__PURE__ */ e.createElement("div", { className: t.header_content }, c ? /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
      "h2",
      {
        className: t.sub_title,
        "aria-label": I18n.t(
          "booking_engine.accessibility.subtitle_section"
        )
      },
      c
    ), /* @__PURE__ */ e.createElement("h1", { className: t.title }, h)) : /* @__PURE__ */ e.createElement("h1", { className: t.title }, h)), m ? /* @__PURE__ */ e.createElement(R, { onClose: m }) : null),
    o ? /* @__PURE__ */ e.createElement(
      "div",
      {
        className: v(t.subtitle, {
          [t.subtitle_with_back]: !!l,
          [t.subtitle_fullscreen]: s
        }),
        "data-testid": "be-header-subtitle",
        onClick: l,
        role: "button",
        tabIndex: 0,
        "aria-label": I18n.t("booking_engine.buttons.back_to_search"),
        onKeyDown: I
      },
      /* @__PURE__ */ e.createElement("div", { className: t.dates }, /* @__PURE__ */ e.createElement(L, { className: t.icon }), b && f ? S(b, f, "long", y) : null),
      /* @__PURE__ */ e.createElement("div", { className: t.guests }, /* @__PURE__ */ e.createElement(K, { className: t.icon }), G({
        totalAdults: w,
        totalChildren: C,
        isChildrenAllowed: D,
        withDash: !1
      }))
    ) : null,
    s && r !== void 0 ? /* @__PURE__ */ e.createElement(
      "div",
      {
        className: t.rooms_available_fullscreen,
        "data-testid": "rooms-available"
      },
      I18n.t("booking_engine.results.results_available", {
        count: r.toString()
      })
    ) : null
  );
};
export {
  U as Header
};
